document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined') return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  document.querySelectorAll('.linesse-bounce-cards').forEach(function (container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('.lb-card'));
    if (!cards.length) return;

    if (isMobile) {
      cards.forEach(function (card) {
        card.style.transform = 'none';
      });
    }

    var baseTransforms = cards.map(function (card) {
      return isMobile ? 'none' : card.dataset.transform || 'none';
    });

    if (prefersReducedMotion) {
      gsap.set(cards, { scale: 1 });
      return;
    }

    gsap.set(cards, { scale: 0 });
    gsap.to(cards, {
      scale: 1,
      stagger: 0.08,
      ease: 'elastic.out(1, 0.6)',
      duration: 1,
      scrollTrigger: {
        trigger: container,
        start: 'top 82%',
        toggleActions: 'play none none none',
      },
    });

    function getNoRotationTransform(transformStr) {
      if (/rotate\([\s\S]*?\)/.test(transformStr)) {
        return transformStr.replace(/rotate\([\s\S]*?\)/, 'rotate(0deg)');
      }
      if (transformStr === 'none') return 'rotate(0deg)';
      return transformStr + ' rotate(0deg)';
    }

    function getPushedTransform(baseTransform, offsetX) {
      var match = baseTransform.match(/translate\(([-0-9.]+)px\)/);
      if (match) {
        var newX = parseFloat(match[1]) + offsetX;
        return baseTransform.replace(/translate\([-0-9.]+px\)/, 'translate(' + newX + 'px)');
      }
      return baseTransform === 'none' ? 'translate(' + offsetX + 'px)' : baseTransform + ' translate(' + offsetX + 'px)';
    }

    function pushSiblings(hoveredIdx) {
      cards.forEach(function (card, i) {
        gsap.killTweensOf(card);
        var base = baseTransforms[i];
        if (i === hoveredIdx) {
          gsap.to(card, { transform: getNoRotationTransform(base), duration: 0.4, ease: 'back.out(1.4)', overwrite: 'auto' });
        } else {
          var offsetX = i < hoveredIdx ? -70 : 70;
          var delay = Math.abs(hoveredIdx - i) * 0.05;
          gsap.to(card, { transform: getPushedTransform(base, offsetX), duration: 0.4, ease: 'back.out(1.4)', delay: delay, overwrite: 'auto' });
        }
      });
    }

    function resetSiblings() {
      cards.forEach(function (card, i) {
        gsap.killTweensOf(card);
        gsap.to(card, { transform: baseTransforms[i], duration: 0.4, ease: 'back.out(1.4)', overwrite: 'auto' });
      });
    }

    if (isMobile) {
      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (card.classList.contains('is-revealed')) return;
          event.preventDefault();
          cards.forEach(function (c) { c.classList.remove('is-revealed'); });
          card.classList.add('is-revealed');
        });
      });
    } else {
      cards.forEach(function (card, idx) {
        card.addEventListener('mouseenter', function () { pushSiblings(idx); });
        card.addEventListener('mouseleave', resetSiblings);
      });
    }
  });
});
